<template>
  <div :class="customClass">
    <img ref="logo" :src="logoHost" />
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'CompanyLogo',
  props: {
    customClass: String,
    logoHost: String,
  },
  mounted() {
    if (!this.logoHost) {
      return
    }

    const $logo = $(this.$refs.logo)
    $logo.on('error', () => {
      $logo.remove()
    })
    $logo.on('load', () => {
      const $head = $(document.head)
      $head.find('[rel = icon]').remove()
      $head.append(
        $(`<link rel="shortcut icon" href="${this.logoHost}"></link>`),
      )
    })
  },
}
</script>

<style scoped>
body.presentation-table-view .logo-tablet,
body.presentation-table-view .logo {
  display: flex;
  align-items: center;
  justify-content: center;
}
body.presentation-table-view .logo img,
body.presentation-table-view .logo-tablet img {
  width: 100%;
  height: auto;
  background-size: contain;
}
body.presentation-table-view .logo {
  width: 150px;
  height: 150px;
}
body.presentation-table-view .logo-tablet {
  margin-top: 13px;
  width: 100px;
  height: 100px;
}
body.presentation-table-view .info .logo {
  margin: 0 auto;
}
</style>
